<template>
    <main class="register-login">
        <div class="container">
            <Header
                title="¿Olvidaste tu clave?"
                text="No te preocupes, puedes recuperarla ingresando tu correo."
            />
            <FormRecoveryPassword />
        </div>
    </main>
</template>

<script>
import FormRecoveryPassword from "@/components/signupAndLogin/FormRecoveryPassword.vue";
import Header from "@/components/signupAndLogin/Header";

export default {
    name: "RecoveryPassword",
    components: {
        Header,
        FormRecoveryPassword,
    },
};
</script>
